import { render, staticRenderFns } from "./SSelectArticleCategory.vue?vue&type=template&id=6799ec12"
import script from "./SSelectArticleCategory.vue?vue&type=script&lang=js"
export * from "./SSelectArticleCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports